const modalBtns = document.getElementsByClassName('js-modal');

for (let index = 0; index < modalBtns.length; index++) {
  const modalBtn = modalBtns[index];
  modalBtn.addEventListener('click', () => {
    const href = modalBtn.href;
    const urlObj = new URL(href);
    const hash = urlObj.hash.replace('#', '');
    if (!hash) return;

    const modal = document.getElementById(hash);
    if (!modal) return;

    document.body.classList.add('modal-open'); 
    modal.style.display = '';
    setTimeout(() => {
      modal.classList.add('modal--open');
    }, 1);
  });
}

const closeBtns = document.getElementsByClassName('js-modal-close');
for (let index = 0; index < closeBtns.length; index++) {
  const closeBtn = closeBtns[index];
  closeBtn.addEventListener('click', () => {
    const modal = closeBtn.closest('.modal');
    if (!modal) return;

    modal.classList.remove('modal--open');
    setTimeout(() => {
      modal.style.display = 'none';
      document.body.classList.remove('modal-open');
    }, 400);
  });
}
